import type { InboxConversation } from "../../types";
import { felixOwnershipStatus, felixOwnershipText } from "./felixOwnership";

/** Whether Felix is replying to this contact, as the bot sees it (FHC-011). */
export function FelixHandoffStatus({
  row,
  now,
}: {
  row: InboxConversation;
  now?: number;
}) {
  const at = now ?? Date.now();
  const status = felixOwnershipStatus(row, at);
  if (!status) return null;
  return (
    <p
      className="text-xs text-muted-foreground"
      data-felix-ownership={status.kind}
    >
      {felixOwnershipText(status, at)}
    </p>
  );
}
